import { render, staticRenderFns } from "./animated-three-d-text-prisms.vue?vue&type=template&id=27568c4c&scoped=true"
import script from "./animated-three-d-text-prisms.vue?vue&type=script&lang=js"
export * from "./animated-three-d-text-prisms.vue?vue&type=script&lang=js"
import style0 from "./animated-three-d-text-prisms.vue?vue&type=style&index=0&id=27568c4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27568c4c",
  null
  
)

export default component.exports